import React from "react";

import { Box } from "@mui/system";
import { Typography } from "@mui/material";

import MintItem from "./MintItem";
import { useSelector } from "react-redux";

export default function MintContractList() {

    const contractList = useSelector((state) => state.contract.items);

    return (
        <>
            <Typography
                sx={{
                    fontWeight: "normal",
                    fontSize: "60px",
                    lineHeight: "48px",
                    fontFamily: "Circular Std",
                    textAlign: "center",
                }}
                variant="h1"
                component="h1"
                gutterBottom
            >
                MINT 
            </Typography>
            <Typography
                sx={{
                    fontWeight: "normal",
                    fontSize: "60px",
                    lineHeight: "48px",
                    fontFamily: "Circular Std",
                    textAlign: "center",
                }}
                variant="h1"
                component="h2"
                gutterBottom
            >
                SELECT CONTRACT 
            </Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, 29%)",
                    gridAutoRows: "minmax(247px, max-content)",
                    gap: "1rem",
                    cursor: "pointer",
                }}
            >
                {contractList.map((item) => (
                    <MintItem contract={item} key={item._id} />
                ))}
            </Box>
        </>
    );
}
